// DialogInvoiceAddress Component
/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import Select from '../../../common/form/select/select.jsx'
import countries from '../../../lib/countries.jsx'
import usastates from '../../../lib/usastates.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Input from '../../../common/form/input/input.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import Util from '../../../lib/util.jsx'

class DialogInvoiceAddress extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      contactName: '',
      street: '',
      postcode: '',
      city: '',
      state: '',
      country: '',
      vatNo: '',
      type: '',
      streetNumber: '',
      dataDate: null,
      contactPersonOptions: [],
      contactPersonId: ''
    }

    this.bVatRequired = false
    this._references = {
      refStreet: React.createRef(),
      refPostcode: React.createRef(),
      refState: React.createRef(),
      refCity: React.createRef(),
      refvatNo: React.createRef(),
      refCountry: React.createRef()
    }
  }

  static get propTypes () {
    return {
      isAddressForPO: PropTypes.bool,
      onSubmit: PropTypes.func,
      message: PropTypes.string,
      teamCountry: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      isAddressForPO: false,
      onSubmit: null,
      message: null,
      teamCountry: ''
    }
  }

  show (invoiceObj, bVatRequired) {
    FabButtonManager.setVisible(false)
    if (invoiceObj) {
      const defaultPersonId =
        invoiceObj.contactPersonOptions.length > 0
          ? invoiceObj.contactPersonOptions[0].value
          : ''
      this.bVatRequired = bVatRequired
        ? !Util.isEuropeCountry(invoiceObj.address.country)
        : false
      this.setState({
        contactName: invoiceObj.contactName ? invoiceObj.contactName : '',
        street: invoiceObj.address.street ? invoiceObj.address.street : '',
        postcode: invoiceObj.address.postcode
          ? invoiceObj.address.postcode
          : '',
        city: invoiceObj.address.city ? invoiceObj.address.city : '',
        state: invoiceObj.address.state ? invoiceObj.address.state : '',
        country: invoiceObj.address.country
          ? invoiceObj.address.country
          : this.props.teamCountry,
        streetNumber: invoiceObj.address.streetNumber
          ? invoiceObj.address.streetNumber
          : '',
        vatNo: invoiceObj.vatNo ? invoiceObj.vatNo : '',
        type: invoiceObj.address.type ? invoiceObj.address.type : '',
        dataDate: new Date(),
        contactPersonOptions: invoiceObj.contactPersonOptions,
        contactPersonId: invoiceObj.contactPerson
          ? invoiceObj.contactPerson
          : defaultPersonId
      })
    }
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      contactName: '',
      street: '',
      postcode: '',
      city: '',
      state: '',
      country: '',
      vatNo: '',
      showError: false,
      type: '',
      streetNumber: '',
      contactPersonOptions: [],
      contactPersonId: ''
    })
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = ev => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  }

  showError () {
    this.setState({ showError: true })
  }

  render () {
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'

    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        type='medium'
        className='dialog-invoiceaddress'
      >
        <div className='dialog-form invoiceaddress-form'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='invoice.form.finalizeAddressTitle' />
                <span className='subtitle'>
                  <IntlMessage ident='invoice.form.finalizeAddressSubTitle' />
                </span>
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='invoice.form.finalizeAddrErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <span className='title'>
              {this.props.message && <IntlMessage ident={this.props.message} />}
            </span>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        {this.state.contactPersonOptions &&
                        this.state.contactPersonOptions.length > 0 ? (
                          <Select
                            options={this.state.contactPersonOptions}
                            name='contactPersonId'
                            className='form-dropdown'
                            label='invoice.form.labelContactPerson'
                            value={this.state.contactPersonId}
                            onChange={this._onChangeInput.bind(
                              this,
                              'contactPersonId'
                            )}
                          />
                        ) : (
                          <Input
                            type='text'
                            name='contactPersonId'
                            value={this.state.contactPersonId}
                            label='invoice.form.labelAttention'
                            size={10}
                            maxLength={100}
                            validations={[this.props.isAddressForPO ? '' : 'required']}
                            styleDotted
                            onChange={this._onChangeInput.bind(
                              this,
                              'contactPersonId'
                            )}
                          />
                        )}
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='street'
                          value={this.state.street}
                          label='invoice.form.labelStreet'
                          ref={this._references.refStreet}
                          size={10}
                          maxLength={100}
                          validations={[this.props.isAddressForPO ? '' : 'required']}
                          onChange={this._onChangeInput.bind(this, 'street')}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol2 col-left'>
                        <Input
                          type='text'
                          name='postcode'
                          value={this.state.postcode}
                          label='invoice.form.labelZipCode'
                          ref={this._references.refPostcode}
                          size={10}
                          maxLength={100}
                          validations={[this.props.isAddressForPO ? '' : 'required']}
                          onChange={this._onChangeInput.bind(this, 'postcode')}
                        />
                      </div>
                      <div className='formcol2'>
                        {this.state.country === 'US' ? (
                          <Select
                            options={usastates}
                            name='state'
                            label='invoice.form.statePlaceholder'
                            className='form-dropdown'
                            ref={this._references.refState}
                            validations={[this.props.isAddressForPO ? '' : 'required']}
                            onChange={this._onChangeInput.bind(this, 'state')}
                            value={this.state.state}
                          />
                        ) : (
                          <Input
                            type='text'
                            name='city'
                            value={this.state.city}
                            label='invoice.form.labelCity'
                            ref={this._references.refCity}
                            size={10}
                            maxLength={100}
                            validations={[this.props.isAddressForPO ? '' : 'required']}
                            onChange={this._onChangeInput.bind(this, 'city')}
                          />
                        )}
                      </div>
                    </div>
                    {this.state.country === 'US' && (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Input
                            type='text'
                            name='city'
                            value={this.state.city}
                            label='invoice.form.labelCity'
                            ref={this._references.refCity}
                            size={10}
                            maxLength={100}
                            validations={[this.props.isAddressForPO ? '' : 'required']}
                            onChange={this._onChangeInput.bind(this, 'city')}
                          />
                        </div>
                      </div>
                    )}
                    <div className='formrow'>
                      <div className='formcol'>
                        <Select
                          options={countries}
                          name='country'
                          multilingualOptions
                          label='invoice.form.optionsPlaceholder'
                          className='form-dropdown'
                          ref={this._references.refCountry}
                          validations={[this.props.isAddressForPO ? '' : 'required']}
                          onChange={this._onChangeInput.bind(this, 'country')}
                          value={this.state.country}
                        />
                      </div>
                    </div>
                    {this.props.teamCountry !== 'US' && (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Input
                            type='text'
                            name='vatNo'
                            value={this.state.vatNo}
                            label='invoice.form.labelVatNo'
                            ref={this._references.refvatNo}
                            size={10}
                            maxLength={100}
                            validations={[this.props.isAddressForPO ? '' : this.bVatRequired ? 'required' : '']}
                            styleDotted
                            onChange={this._onChangeInput.bind(this, 'vatNo')}
                          />
                          <div className='formsubinfo'>
                            <span className='info'>
                              <IntlMessage ident='invoice.form.finalizeReqInfo' />
                              <a
                                className='formlink'
                                href='http://ec.europa.eu/taxation_customs/vies/'
                                target='_blank'
                                rel='noopener noreferrer'
                              >
                                <span className='linktext'>
                                  <IntlMessage ident='invoice.form.vatURL' />
                                </span>
                                <span className='formact'>
                                  <i className='icon icon-info-link' />
                                </span>
                              </a>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              title='invoice.form.editInvoiceSave'
              canHover={false}
              onClick={this._onFormSubmit.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onFormSubmit (ev) {
    ev.preventDefault()

    let noErrors = 0

    if (
      this._references.refStreet.current &&
      !this._references.refStreet.current.validate()
    ) {
      noErrors++
    } else if (
      this._references.refPostcode.current &&
      !this._references.refPostcode.current.validate()
    ) {
      noErrors++
    } else if (
      this._references.refState.current &&
      !this._references.refState.current.validate()
    ) {
      noErrors++
    } else if (
      this._references.refCity.current &&
      !this._references.refCity.current.validate()
    ) {
      noErrors++
    } else if (
      this._references.refvatNo.current &&
      !this._references.refvatNo.current.validate()
    ) {
      noErrors++
    } else if (
      this._references.refCountry.current &&
      !this._references.refCountry.current.validate()
    ) {
      noErrors++
    }

    if (noErrors === 0) {
      const updateObj = {
        address: {
          street: this.state.street,
          postcode: this.state.postcode,
          city: this.state.city,
          country: this.state.country,
          type: this.state.type,
          streetNumber: this.state.streetNumber
        },
        selectedContactPerson: null
      }

      if (this.props.teamCountry !== 'US') {
        updateObj.vatNo = this.state.vatNo
      }

      // save state if contact country is US
      if (this.state.country === 'US') {
        updateObj.address.state = this.state.state
      }

      // Create Contact Persons
      if (this.state.contactPersonId) {
        if (
          this.state.contactPersonOptions &&
          this.state.contactPersonOptions.length <= 0
        ) {
          updateObj.contactPersons = [
            {
              name: this.state.contactPersonId,
              email: ''
            }
          ]

          updateObj.selectedContactPerson = updateObj.contactPersons[0]
        } else {
          const contactPerson = _.find(
            this.state.contactPersonOptions,
            obj => obj.value === this.state.contactPersonId
          )
          if (contactPerson && contactPerson.obj) {
            updateObj.selectedContactPerson = {
              name: contactPerson.obj.name || '',
              email: contactPerson.obj.email || ''
            }
          }
        }
      }

      if (this.props.onSubmit) {
        this.props.onSubmit(updateObj, true)
      }
    } else {
      this.setState({ showError: true })
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onChangeInput (name, value) {
    if (name === 'country') {
      this.bVatRequired = Util.isEuropeCountry(value)
    }

    const stateObj = {
      [name]: value
    }

    if (name === 'country' && value !== 'US') {
      stateObj.state = ''
    }

    this.setState(stateObj)
  }
}

export default DialogInvoiceAddress
